<template>
  <div>
    <el-dialog :visible.sync="dialogVisible" z-index="2000">
      <div class="content">
        <div class="title">
          <img src="@/assets/image/icon_info.webp" v-if="type === 'info'" class="icon" />
          <img src="@/assets/image/icon_error.png" v-if="type === 'error'" class="icon" />
          <img
            src="@/assets/image/icon_success.png"
            v-if="type === 'success'"
            class="icon"
          />
          <div>{{ title }}</div>
        </div>
        <div class="main">
          {{ content }}
        </div>
        <div slot="footer" class="footer">
          <el-button @click="close" size="mini">{{ cancelText }}</el-button>
          <el-button type="primary" @click="confirm" size="mini">{{ confirmText }}</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      dialogVisible: false,
      type: "info",
      title: "认证提醒",
      content: "当前账号信息与创建企业法人信息不一致，无法创建",
      confirmText: "确 定", 
      cancelText: "取 消",
    };
  },
  created() {},
  computed: {},
  methods: {
    close() {
      this.onHide();
      this.$emit("close");
    },
    confirm() {
      this.onHide();
      this.$emit("confirm");
    },
    onShow({ type, title, content,confirmText,cancelText } = {}) {
      type && (this.type = type);
      title && (this.title = title);
      content && (this.content = content);
      confirmText && (this.confirmText = confirmText);
      cancelText && (this.cancelText = cancelText);
      this.dialogVisible = true;
    },
    onHide() {
      this.dialogVisible = false;
    },
  },
};
</script>

<style scoped lang="scss">
.content {
  .title {
    height: 58px;
    font-size: 18px;
    font-weight: 500;
    display: flex;
    align-items: center;
    padding: 0 16px;
    gap: 6px;
    .icon {
      width: 18px;
      height: 18px;
    }
  }

  .main {
    font-size: 14px;
    font-weight: 350;
    line-height: 22px;
    color: #666666;
    padding: 0 16px;
  }
  .footer {
    height: 64px;
    display: flex;
    align-items: center;
    padding: 0 16px;
    justify-content: flex-end;
  }
}
</style>
